export enum FunnelDialogTabTypes {
  AUTOMATIONS = 'Automations',
  ALERTS = 'Alerts',
  ASSIGNMENTS = 'Assignments',
  HISTORY = 'Version History',
}
